import React from "react";
import "./LoginOverlay.css";

export default function LoginOverlay({ open, onClose, children }) {
  if (!open) return null;

  return (
    <div className="login-backdrop" onClick={onClose}>
      <div className="login-modal" onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}
